import Split from 'react-split';// make sure your styles are applied
import NavBar from '../../Universal Components/NavBar/NavBar'
import Description from './DescriptionAndSolution/Description';
import IDE from './IDE/IDE';
import RunTests from './RunAndTestCases/RunTests';
import "./SolvePage.css"
import React, {useEffect, useState } from 'react';
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth } from "../../Firebase/InitFirebase";

import { useLocation, useNavigate } from "react-router-dom"; // This is used to foreward problem ID from the table to the solve page & run button (https://www.reddit.com/r/reactjs/comments/r1onuc/passing_objects_through_usenavigate/)
import { getProblemById } from '../../Data/ProblemsMethod';

export const IDEContext = React.createContext();

export default function ProblemPage(){
    
    const { state } = useLocation(); // Unpack { state: { problem_id : problemID } }); [comes from router]
    const navigate = useNavigate(); 
    useEffect(() => { // Used to avoid rendering black page that could otherwise be generated by going direct to this url (oppsed to by clicking and passing props)
        if (state == null || state?.problem_id == null) {
            navigate("/"); 
        }
    }, [state]);

    // A redundant enforcement of being email verifed, purpose is to make it so that if a user tampers with client side js, they will have to do prohibitively often 
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, currentUser => {
            const isEmailPasswordUser = currentUser?.providerData[0]?.providerId === "password";
            if(currentUser && isEmailPasswordUser && !currentUser.emailVerified) {
                signOut(auth).then(() => {
                    console.log("User signed out because they were not email verified, this should only happen if user tampers with cleint js");
                }).catch(()=>{
                    console.log("[ERROR] Enforcing email verification in ProblemPage");
                });
            }
        })


       
        return () => unsubscribe();
    }, []);

    const [IDEText, setIDEText] = useState("");
    const currProblem =  getProblemById(state?.problem_id);

    const [selected_language, set_selected_language] = useState(currProblem?.language_ids?.[0] ?? null);


    useEffect(()=>{
        console.log("Language ID in SolvePage: ", selected_language)
    }, [selected_language]);

    if (state == null || state.problem_id == null || currProblem == null)  return null; 
    
    return(
        <div className="outer-layer">
            <div className='split-container'>

                <NavBar/>

                <Split className="split-horizontal" minSize={1}>
                    <div className='A'>  
                        <Description problemID={state.problem_id}/>
                    </div>

                    <div className='B'> 
                        <div className='vertical-split-container'>
                            <IDEContext.Provider value={[IDEText, setIDEText]}> {/* Makes child components able to call these methods without passing props*/}
                                <Split
                                    className="split-vertical"
                                    direction="vertical"
                                    minSize={1}
                                >
                                    
                                        <div className="C">
                                            <IDE 
                                                problemID = {state.problem_id}
                                                validLanguages = {currProblem?.language_ids}
                                                selectedLanguage={selected_language}
                                                setSelectedLanguage = {set_selected_language}
                                            />
                                        </div>

                                        <div className="D">

                                            <RunTests
                                                selectedLanguage={selected_language}
                                            />
                                        </div>
                                    

                                </Split>
                            </IDEContext.Provider>
                        </div>
                    </div>
                </Split>
            </div>
        </div>
        
    );
}

